import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { config } from './config';
import { LightFragmentMatcher } from './LightFragmentMatcher';

export const httpLink = new HttpLink({
	uri: config.GRAPHQL_API,
	fetchOptions: {
		'no-cors': true,
		method: 'POST',
	},
});

export const fragmentMatcher = new LightFragmentMatcher();

export const cache = new InMemoryCache({
	fragmentMatcher,
	dataIdFromObject: (object: any) => object.id,
});
